/**
 * ServiceOrder machine guards — pure, no side effects.
 * `paymentConfirmed` is set by the payment stub (Sprint 04) on webhook /
 * simulate confirmation before the PAY event is sent.
 */
export const paymentConfirmed = ({ context }) => !!context.paymentConfirmed;
//# sourceMappingURL=service-order.js.map